import Component from './FilesTable';
import withQuery from './FilesTable.relay';
export default withQuery(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/FilesTable/index.js